
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/integration/account-management",
      function () {
        return require("private-next-pages/admin/integration/account-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/integration/account-management"])
      });
    }
  